import { createAsyncThunk } from "@reduxjs/toolkit";
import { type CreateUserParams, type DmsUser } from "../../../domain/entities/user";
import { type UsersDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const createUser = createAsyncThunk<
  DmsUser,
  CreateUserParams,
  { dispatch: UsersDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.CREATE_USER, async (params, { extra }) => {
  return await extra.usersRepo.createUser(params);
});
